import { render, staticRenderFns } from "./MarketClient.vue?vue&type=template&id=d5107c80&scoped=true&"
import script from "./MarketClient.vue?vue&type=script&lang=js&"
export * from "./MarketClient.vue?vue&type=script&lang=js&"
import style0 from "./MarketClient.vue?vue&type=style&index=0&id=d5107c80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5107c80",
  null
  
)

export default component.exports